import { Component } from '@angular/core';

import { PRODUCT_NAME } from '../../../core/constant/product.constant';

@Component({
    standalone: false,
    selector: 'app-admin-footer',
    templateUrl: './admin-footer.component.html',
})
export class AdminFooterComponent {
    protected readonly productName = PRODUCT_NAME;
}
